const AnalystMenuItems = [
];

export default AnalystMenuItems;